<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Distribution
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/dproduct/index">Manage Product</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        {{ product.Name || 'View Product' }}
      </h6>

      <div class="container-fluid">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end mb-2">
          <button class="btn btn-sm btn-outline-primary bdr-rad" @click="goBack">Back</button>
        </div>

        <div class="card bdr-rad2 shadow p-2" v-if="isLoading">
          <div class="card-body">
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="card bdr-rad2 shadow p-2">
          <div class="card-body">
            <div class="row">
              <div class="col-md-3 mb-3 text-center">
                <img
                  v-if="product.Photo"
                  :src="photoUrl(product.Photo)"
                  class="detail-photo"
                  alt="Photo"
                />
                <div v-else class="detail-photo placeholder-box">No Photo</div>
              </div>

              <div class="col-md-9">
                <table class="table table-sm table-borderless" style="font-size: small">
                  <tbody>
                    <tr>
                      <td><b>SKU</b></td>
                      <td>{{ product.SKU }}</td>
                    </tr>
                    <tr>
                      <td><b>Name</b></td>
                      <td>{{ product.Name }}</td>
                    </tr>
                    <tr>
                      <td><b>Price</b></td>
                      <td>{{ product.Price }}</td>
                    </tr>
                    <tr>
                      <td><b>Winery</b></td>
                      <td>{{ product.Winery }}</td>
                    </tr>
                    <tr>
                      <td><b>Country</b></td>
                      <td>{{ product.Country }}</td>
                    </tr>
                    <tr>
                      <td><b>Region</b></td>
                      <td>{{ product.Region }}</td>
                    </tr>
                    <tr>
                      <td><b>Varietal</b></td>
                      <td>{{ product.Varietal }}</td>
                    </tr>
                    <tr>
                      <td><b>Type</b></td>
                      <td>{{ product.Type }}</td>
                    </tr>
                    <tr>
                      <td><b>Body</b></td>
                      <td>{{ product.Body }}</td>
                    </tr>
                    <tr>
                      <td><b>Description</b></td>
                      <td>{{ product.Description }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: {
    TopNavbar,
    ContentFooter,
  },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      product: {},
      isLoading: true,
    };
  },
  mounted() {
    this.loadProduct();
  },
  methods: {
    goBack() {
      this.$router.push('/dproduct/index');
    },
    photoUrl(path) {
      if (!path) {
        return '';
      }

      if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
      }

      return path.startsWith('/') ? path : '/' + path;
    },
    async loadProduct() {
      try {
        const { data } = await axios.get('/dproduct/view?id=' + this.$route.query.id, {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-Type': 'application/json',
          },
        });
        this.product = data.all_data || {};
      } catch (error) {
        console.log(error.response || error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.bdr-rad {
  border-radius: 12px;
}

.bdr-rad2 {
  border-radius: 15px;
}

.decoration {
  text-decoration: none;
  color: white !important;
}

.font1 {
  font-size: 13px !important;
}

.manage-boder {
  border-bottom: 2px solid #007bff;
  border-top: 2px solid #007bff;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}

.detail-photo {
  width: 220px;
  height: 220px;
  object-fit: cover;
  border-radius: 14px;
  border: 1px solid #d6d6d6;
}

.placeholder-box {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f7f7;
  color: #666;
}
</style>
